import '../../css/content.css';
import React, {useContext, useLayoutEffect, useState} from 'react';
import { VideoContext } from '../../context/VideoContext';
import { VideoData } from "../../data/Videos";
import { VideoPlayerWithTranscript, VideoTitle } from "../VideoPlayer";
import VideoContainer from "../VideoContainer";
import Tooltip from '../Tooltip';
import map from '../../img/group-3476.png'

const Content0 = () => {

  const [mounted, setMounted] = useState(false);
  const [videoData, setVideoData] = useState({});
  const { currentDeepDiveIndex } = useContext(VideoContext);

  useLayoutEffect(() => {
    if (currentDeepDiveIndex !== 0) return;
    setVideoData(VideoData.find((video) => video.id === "843697919"));
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, [currentDeepDiveIndex]);

  return (
    <>
      {/* 1 */}
      <div id="partial-0" className="partial-container partial-container-1">
        <div className="cont-1">
          <p>While <Tooltip>NTM</Tooltip> occurs throughout the US, these 10 states report the most cases.</p>
          <img src={map} alt="map" />
        </div>
        <div className="cont-2">
          <p><Tooltip>MAC</Tooltip> <Tooltip>bacteria</Tooltip> can survive in almost any climate, from warm and humid to cold and snowy.</p>
        </div>
      </div>
      {/* 2 */}
      <div id="partial-1" className="partial-container partial-container-2">
        <div className="min-h-fit">
          {
            (mounted) && 
            <>
              <VideoTitle>{videoData.title}</VideoTitle>
              <VideoContainer>
                <VideoPlayerWithTranscript videoData={videoData} />
              </VideoContainer>
            </>
          }
          
        </div>
        
      </div>
    </>
  )
};

export default Content0;